import { useState, useEffect, useLayoutEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAtom } from 'jotai'
import {
    UserSession,
    AdminUser
} from '../../utils'
import { Client, Account } from "appwrite";
import ThemeOption from '../../components/ThemeOption'
import LogoLoader from '../../components/LogoLoader';
import DashboardMenu from '../../components/DashboardMenu'
import FileUpload from '../../components/FileUpload'
import RunFunction from '../../components/RunFunction'
import Multiselect from '../../components/Multiselect'
import Toggle from '../../components/Toggle'
import Counter from '../../components/Counter'
import InfoTooltip from '../../components/InfoTooltip'
import { storage, functions } from '../../appwrite/config'

import Switch from '@mui/material/Switch';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';

import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import { Input, Tabs, Tab } from '@mui/material'


const client = new Client()
    .setEndpoint(process.env.REACT_APP_ENDPOINT)
    .setProject(process.env.REACT_APP_PROJECT_ID);

const account = new Account(client);


export default function ScheduleExtractor() {
    const navigate = useNavigate()
    const [userSession, setUserSession] = useAtom(UserSession);
    const [tab, setTab] = useState(0);

    const [isLoading, setIsLoading] = useState(true);
    const [showLoadingScreen, setShowLoadingScreen] = useState(false);

    // const [ignoreFirstColumn, setIgnoreFirstColumn] = useState(true);

    const switchTab = (event, newTab) => {
        setTab(newTab);
    };
    
    // Set authenticated session on initial page load
    useEffect(() => {
        const checkSession = async () => {
            try {
                const user = await account.get()
                return user
            } catch (error) {
                navigate('/')
            }
        }
        setUserSession(checkSession())
    }, []);

    // Display loading screen while the page loads
    useLayoutEffect(() => {
        const timeoutId = setTimeout(() => {
            setShowLoadingScreen(true);
        }, 50);
    
        return () => clearTimeout(timeoutId);
    }, []);
    
    useLayoutEffect(() => {
        const timeoutId = setTimeout(() => {
            setIsLoading(false);
        }, 0);
    
        return () => clearTimeout(timeoutId);
    }, []);
    
    if (isLoading && showLoadingScreen) return <LogoLoader />;

    return (<>
        {userSession && <DashboardMenu path="" user={userSession} page={<div className="page-content">
            {/* <div className='theme-options'>
                <ThemeOption theme="dark"/>
                <ThemeOption theme="light"/>
                <ThemeOption theme="purple"/>
            </div> */}
            <Typography variant="h4" gutterBottom>Schedule Extractor</Typography>

            <Tabs
                value={tab}
                onChange={switchTab}
            >
                <Tab icon={<InsertDriveFileOutlinedIcon />} iconPosition="start" label="PDF Scan" />
                <Tab icon={<ImageOutlinedIcon />} iconPosition="start" label="Image Scan" />
            </Tabs>

            <FileUpload multiple type={tab === 0 ? "pdf" : "png jpg jpeg"} />

            {/* Advanced settings */}
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    id="panel1-header"
                >
                    <Typography component="span">Advanced Settings <i>(optional)</i></Typography>
                </AccordionSummary>

                {/* PDF settings */}
                {tab === 0 && <AccordionDetails>
                    <Toggle
                        text="Additional cleanup using AI"
                        state={false}
                        widgetName="schedule-extractor"
                        docKey="pdf_gptCleanup"
                        note="(slower)"
                    />
                    {/* <InfoTooltip text="Will be ignored if additional cleanup is used." /> */}
                    <Toggle
                        text="Preserve first column formatting"
                        state={true}
                        widgetName="schedule-extractor"
                        docKey="pdf_ignoreFirstColumn"
                    />
                    {/* <Toggle
                        text="Show schedules in process log"
                        state={true}
                        widgetName="schedule-extractor"
                        docKey="pdf_logImages"
                    /> */}
                    
                    <br/>
                    <Multiselect
                        header="Schedule keywords"
                        docKey="pdf_schedKeywords"
                        options={["Schedule", "Legend"]}
                        inputText="New keyword"
                        resetButtonText="Use Default Keywords"
                        widgetName="schedule-extractor"
                    />
                    <br/>
                    <Multiselect
                        header="Header keywords"
                        docKey="pdf_headKeywords"
                        options={["qty", "quantity", "symbol", "key"]}
                        inputText="New keyword"
                        resetButtonText="Use Default Keywords"
                        widgetName="schedule-extractor"
                    />
                    <br/>

                    <Counter
                        number={50}
                        header="Schedule margin"
                        label="Pixels"
                        widgetName="schedule-extractor"
                        docKey="pdf_schedMargin"
                    />
                    <Counter
                        number={500}
                        header="Minimum schedule box-size"
                        label="Pixels"
                        widgetName="schedule-extractor"
                        docKey="pdf_minSchedSize"
                    />
                </AccordionDetails>}

                {/* Image settings */}
                {tab === 1 && <AccordionDetails>
                    <Toggle
                        text="Additional cleanup using AI"
                        state={true}
                        widgetName="schedule-extractor"
                        docKey="img_gptCleanup"
                        note="(slower)"
                    />
                    <Toggle
                        text="Preserve first column formatting"
                        state={true}
                        widgetName="schedule-extractor"
                        docKey="img_ignoreFirstColumn"
                    />
                </AccordionDetails>}
            </Accordion>
            <br/>
            <RunFunction
                name="schedule-extractor"
                path={tab === 0 ? "/pdf" : "/img"}
                button={tab === 0 ? "Process PDF" : "Process Image"}
            />
        </div>} />}
    </>)
}